import { post } from '..';

interface CreateTicketProps {
  solveTagId: string,
  issue: string,
  issueId?: string,
  base64Image?: string,
  userDeviceId?: string,
}

const createTicket = ({
  solveTagId, issue, issueId, base64Image, userDeviceId,
}: CreateTicketProps) => {
  const body: CreateTicketProps = {
    solveTagId, issue, issueId, userDeviceId,
  };
  if (base64Image?.length > 0) body.base64Image = base64Image;
  return post('assets/v2/tickets', body);
};

export default createTicket;
